import React from "react";
import { PageHeader } from "@/components/tmc/common";
import { BotsSection } from "@/pages/Admin";

export default function Bots() {
  return (
    <div data-testid="bots-page">
      <PageHeader title="Boty sygnałowe" subtitle="SMC · Price Action · Ultra Scalping · BTC Snajper" />
      <BotsSection />
    </div>
  );
}
